import { createContext, useContext } from "react";

export const BottomNavContext = createContext({
  isBottomNavVisible: false,
  bottomNavHeight: 14, // Tailwind height unit (e.g., 14 for h-14)
});

export const useBottomNav = () => useContext(BottomNavContext); 